import * as React from "react";
const SvgFiRrFaceSmileHalo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-smile-halo_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 6.617-5.383 12-12 12S0 18.617 0 12c0-1.505.275-2.974.818-4.364a.999.999 0 1 1 1.863.727 10 10 0 0 0-.682 3.636c0 5.514 4.486 10 10 10s10-4.486 10-10a9.9 9.9 0 0 0-.682-3.636 1 1 0 0 1 1.863-.727c.543 1.39.818 2.858.818 4.364zM7 12c0-1.054.68-2 1-2s1 .946 1 2a1 1 0 1 0 2 0c0-1.892-1.232-4-3-4s-3 2.108-3 4a1 1 0 1 0 2 0m12 0c0-1.892-1.232-4-3-4s-3 2.108-3 4a1 1 0 1 0 2 0c0-1.054.68-2 1-2s1 .946 1 2a1 1 0 1 0 2 0m-7 7c3.107 0 5.563-2.162 5.666-2.254a.999.999 0 0 0-1.33-1.493c-.02.018-2.005 1.748-4.336 1.748s-4.311-1.726-4.336-1.748a1 1 0 0 0-1.33 1.493C6.437 16.838 8.893 19 12 19M1 3C1 .216 9.42 0 12 0s11 .216 11 3-8.42 3-11 3S1 5.784 1 3m2.502 0C4.724 3.449 7.641 4 12 4s7.276-.551 8.498-1C19.276 2.551 16.359 2 12 2s-7.276.551-8.498 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-smile-halo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSmileHalo;
